export default __webpack_public_path__ + "static/IndividualAttention-5084afbf03962bae156238e9857fdf59.svg";